module.exports = __webpack_public_path__ + "img/cvlogo.6bb550ea.jpg";